export default "__VITE_ASSET__ChxKfh0r__"